import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import moment from 'moment'

import * as rotativeInventoryActions from 'action/rotativeInventory'
import * as reportActions from 'action/report'

import CommonReport from 'component/commonReport/CommonReport'
import columns from 'component/report/rupture/columns'
import applyMask from 'component/report/utils/Formatter'

const RUPTURE_CSV = 45

let signalController;

RuptureIrc.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  current: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  ruptureIrcList: PropTypes.array.isRequired,
  fetchRotativeInventoryFlux: PropTypes.func.isRequired,
  fetchFluxReport: PropTypes.func.isRequired,
}

function RuptureIrc(props) {
  const {
    auth: {
      user: { dsToken },
    },
    auth: { user },
    translate,
    fetchRotativeInventoryFlux,
    fetchFluxReport,
  } = props


  const [formData, setFormData] = useState({})
  const [tableColumns, setTableColumns] = useState(columns)

  const fields = [
    {
      type: 'branchs',
      name: 'idBranches',
      label: translate('irc.store'),
      help_text: translate('irc.choose-store'),
      error_text: translate('field_must_be_filled'),
      required: !user.isLdapInManager,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          listRegionsAndBranchs: e.target.value,
        })
      },
    },
    {
      type: 'sections',
      name: 'lsSections',
      label: translate('irc.section'),
      help_text: translate('irc.choose-section'),
      error_text: translate('field_must_be_filled'),
      required: false,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          sectionInputContent: e,
        })
      },
      attrs: {
        disabled: Boolean(formData.cdLm) && formData.cdLm.length > 0,
      },
    },
    {
      type: 'input',
      name: 'cdLm',
      label: translate('lm_label'),
      help_text: translate('mobile.hint.lm'),
      error_text: translate('field_must_be_filled'),
      required: false,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          cdLm: e.target.value,
        })
      },
      attrs: {
        disabled:
          Boolean(formData.sectionInputContent) &&
          formData.sectionInputContent.length > 0,
        minLength: 8,
        maxLength: 8,
        mask: '99999999',
      },
    },
    {
      type: 'date_range',
      name: 'dtRange',
      label: translate('field.period.hint'),
      help_text: translate('kardex.field.dtRef.placeholder'),
      error_text: translate('field_must_be_filled'),
      required: true,
    },
  ]

  const onSubmit = (paramsDataFormFields, setResponseInTable)=>{
    const formDataFieldsFormated = formatDataFormFields(paramsDataFormFields)

    signalController = new AbortController();

    fetchRotativeInventoryFlux(
      dsToken,
      formDataFieldsFormated,
      (reportData, count) => {

        setFormData({
          ...formData,
          ...formDataFieldsFormated,
        })

        updateColumnsToRenderInTable()
        setResponseInTable(
          formatResponseToAddInTable(
            reportData, count
          )
        )
      },
      () => {
        setResponseInTable({})
        setFormData({})
      }, signalController
    )
  }

  async function onExport(callback) {
    signalController = new AbortController();
    await fetchFluxReport(
      dsToken, 
      { tpReport: RUPTURE_CSV }, 
      formData,
      translate,
      signalController
    )

    const callbackReturn = true
    callback(callbackReturn)
  }

  function formatDataFormFields({
    cdLm,
    dtRange,
    idBranches,
    lsSections,
    limit,
    page,
    order,
    orderDirection,
  }) {
    const formDataFieldsFormated = {
      cdLm,
      cdSection: null,
      order,
      orderDirection,
      dtEnd: dtRange ? moment(dtRange[1]).format('DD/MM/YYYY') : '',
      dtStart: dtRange ? moment(dtRange[0]).format('DD/MM/YYYY') : '',
      idBranches,
      idRegions: [],
      listRegionsAndBranchs: formData.listRegionsAndBranchs,
      lsSections,
      limit,
      page,
      ruptureIrc: true,
    }

    return formDataFieldsFormated
  }

  function formatResponseToAddInTable(ruptureReports) {

    const response = { 
      total: ruptureReports.pages.totalCount, 
      data: [] 
    };


    const ruptureReportsFormated = []
    let i = 0

    for (const report of ruptureReports.resultList || []) {
      ruptureReportsFormated[i] = {}
      for (const c in columns) {
        const col = columns[c]
        if (col.render) {
          if (report[col.field] || report[col.field] === 0) {
            if (col.field === 'cdSection') {
              ruptureReportsFormated[i][
                col.field
              ] = `${report.cdSection} - ${report.dsSection}`
            } else {
              ruptureReportsFormated[i][col.field] = applyMask(
                col.type,
                report[col.field],
                translate
              )
            }
          } else {
            ruptureReportsFormated[i][col.field] = '-'
          }
        }
      }
      i++
    }

    response.data = ruptureReportsFormated

    console.log("Dados formatados para a tabela:", ruptureReportsFormated);

    return response
  }

  function updateColumnsToRenderInTable() {
    const columnsToRender = {}

    const isRenderBranchColumn =
      typeof formData.listRegionsAndBranchs === 'undefined' ||
      formData.listRegionsAndBranchs.length !== 1
    const isRenderSectionColumn =
      typeof formData.sectionInputContent === 'undefined' ||
      formData.sectionInputContent.length !== 1

    for (const columnPropName in columns) {
      const isBranchColumn = columnPropName === 'dsBranch'
      const isSectionColumn = columnPropName === 'cdSection'

      if (
        !(!isRenderBranchColumn && isBranchColumn) &&
        !(!isRenderSectionColumn && isSectionColumn)
      ) columnsToRender[columnPropName] = columns[columnPropName]
    }

    setTableColumns(columnsToRender)
  }

  return (
    <CommonReport
      isFlux
      title={translate('ruptureIrc.rupture.title')}
      order
      defaultOrder='dtInventory'
      onExport={onExport}
      onSubmit={onSubmit}
      columns={tableColumns}
      fields={fields}
      user={user}
      limit={10}
      translate={translate}
      emptyReportMsg='no.data.found'
    />
  )
}

function mapStateToProps({ rotativeInventoryReducer, paginateReducer }) {
  return {
    ruptureIrcList: rotativeInventoryReducer.records,
    pages: paginateReducer.pages,
    count: paginateReducer.count,
    current: paginateReducer.current,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...rotativeInventoryActions,
      ...reportActions,
    },
    dispatch
  )
}

const RuptureIrcTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RuptureIrc)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RuptureIrcTranslated)

export { RuptureIrc }
